<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="100">
                <Row>
                    <Col span="12">
                    <FormItem :label="$t('cname')" prop="zh-cn_cname">
                        <Input v-model="formData['zh-cn_cname']" :placeholder="$t('input')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem :label="$t('code')" prop="func_code">
                        <Input v-model="formData.func_code" :placeholder="$t('input')"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                    <FormItem :label="$t('web_url')" prop="web_url">
                        <Input v-model="formData.web_url" :placeholder="$t('input')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem :label="$t('sort')" prop="sort_id">
                        <Input v-model="formData.sort_id" :placeholder="$t('input')"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                    <FormItem :label="$t('icon')" prop="icon">
                        <Input v-model="formData.icon" :placeholder="$t('input')"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem :label="$t('icon_color')" prop="color">
                        <Input v-model="formData.color" :placeholder="$t('input')"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('system_group')" prop="admin_flag">
                            <Select :disabled="admin_flag_disabled" v-model="formData.admin_flag">
                                <Option :value="item.key" v-for="item in admin_flags" :key="item.key">{{item.value}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cat_id')" prop="cat_id">
                            <Select v-model="formData.cat_id" :placeholder="$t('select')">
                                <Option :value="item.key" v-for="item in cat_id" :key="item.key">{{item.value}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('ex_type')">
                            <Input v-model="formData.ex_type" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <!-- <Row>
                    <Col span="12">
                        <FormItem :label="$t('system_use')">
                            <RadioGroup v-model="formData.s0_flag">
                                <Radio label="1">{{$t('yes')}}</Radio>
                                <Radio label="0">{{$t('no')}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org0_use')">
                            <RadioGroup v-model="formData.s1_flag">
                                <Radio label="1">{{$t('yes')}}</Radio>
                                <Radio label="0">{{$t('no')}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org1_use')">
                            <RadioGroup v-model="formData.s2_flag">
                                <Radio label="1">{{$t('yes')}}</Radio>
                                <Radio label="0">{{$t('no')}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org2_use')">
                            <RadioGroup v-model="formData.s3_flag">
                                <Radio label="1">{{$t('yes')}}</Radio>
                                <Radio label="0">{{$t('no')}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row> -->
                <FormItem :label="$t('cdesc')" prop="zh-cn_cdesc">
                    <Input v-model="formData['zh-cn_cdesc']" type="textarea" :autosize="{minRows: 2,maxRows: 3}" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('cname_tw')" prop="zh-tw_cname">
                    <Input v-model="formData['zh-tw_cname']" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('cdesc_tw')" prop="zh-tw_cdesc">
                    <Input v-model="formData['zh-tw_cdesc']" type="textarea" :autosize="{minRows: 2,maxRows: 3}" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('cname_en')" prop="en_cname">
                    <Input v-model="formData.en_cname" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('cdesc_en')" prop="en_cdesc">
                    <Input v-model="formData.en_cdesc" type="textarea" :autosize="{minRows: 2,maxRows: 3}" :placeholder="$t('input')"></Input>
                </FormItem>
                <Row>
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="formData.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="formData.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row>
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="formData.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="formData.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                op: this.$base.getRequest().op,
                admin_flags:[],
                cat_id:[],
                relist: false,
                formData: {
                    func_id:'',
                    func_code: '',
                    sort_id: 99,
                    "zh-cn_cname" : '',
                    "zh-cn_cdesc": '',
                    "zh-tw_cname": '',
                    "zh-tw_cdesc": '',
                    "en_cname": '',
                    "en_cdesc": '',
                    ex_type: '',
                    web_url: '',
                    icon: '',
                    color: '',
                    admin_flag:'',
                    cat_id:'',
                    s0_flag:'',
                    s1_flag:'',
                    s2_flag:'',
                    s3_flag:'',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    func_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    "zh-cn_cname": [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    "zh-cn_cdesc": [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cat_id: [{required: true, message: this.$t('select'), trigger: 'chang'}],
                }
            }
        },
        computed:{
            admin_flag_disabled:function () {
                if(this.op == "add"){
                    return this.formData.func_type=='G'?false:true;
                }
                else{
                    return this.formData.func_type=='P'?false:true;
                }
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.func_id = this.$base.getRequest().id;

            if(!this.formData.func_id){
                this.getLoad();
            }
            else{
                this.getInfo();
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                this.$base.showLoading();
                this.$request.sendPost("func/before-add",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.admin_flags = data.admin_flag;
                        this.cat_id = data.cat_id;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var data = {
                    func_id: this.formData.func_id
                };
                this.$base.showLoading();
                this.$request.sendPost("func/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.admin_flags = data.admin_flag;
                        this.cat_id = data.cat_id;
                        this.formData = this.$base.leftJson(this.formData, data.info);
                        this.formData.func_type = data.info.func_type
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op=='upd'?"func/upd":"func/add";

                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/func_save.vue